<template>
	<div>
		Library page
	</div>
</template>
<script>
	export default 
	{
		created () 
		{
			document.title = "Library | Bookplate";
		}
	}
</script>